export const BASIC_AUDIT_STATUS = [
  { name: '待审核', code: 'WAIT', class: 'yellow' },
  { name: '审核中', code: 'AUDITING', class: 'blue' },
  { name: '审核通过', code: 'PASS', class: 'green' },
  { name: '审核失败', code: 'REFUSE', class: 'red' },
  { name: '未上传', code: 'NOT_UPLOADED', class: 'cmain' }
]
